import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import Config from './GraphQL.config';

export const GraphQL = props => {
  const graphQLConfig = new Config();

  const link = graphQLConfig.getConfig();
  const graphQLClient = new ApolloClient({
    clientState: {
      //TODO - local state vars go here
      //defaults: {urlInfo: {url: window.location.href}}
    },
    link,
    cache: new InMemoryCache({ addTypename: false })
  });
  return (
    <ApolloProvider client={graphQLClient}>{props.children}</ApolloProvider>
  );
};
